import { render } from "./B2bPageApprovalFlowByLevels.vue?vue&type=template&id=9dcb07d8&scoped=true&lang=pug"
import script from "./B2bPageApprovalFlowByLevels.vue?vue&type=script&lang=js"
export * from "./B2bPageApprovalFlowByLevels.vue?vue&type=script&lang=js"

import "./B2bPageApprovalFlowByLevels.vue?vue&type=style&index=0&id=9dcb07d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dcb07d8"]])

export default __exports__